import _ from 'lodash'
import { createTheme } from '@mui/material/styles'

import { THEME_MODE_DARK } from '../../constants/theme'

import typography from './Typography'
import shadows from './Shadows'
import components from './Override'

const baseTheme = {
  direction: 'ltr',
  palette: {
    primary: {
      main: '#00a0e3',
      light: '#e5f7ff',
      dark: '#007eb3',
      contrastText: '#ffffff'
    },
    secondary: {
      main: '#d82a90',
      light: '#fbe9f4',
      dark: '#c22480',
      contrastText: '#ffffff'
    },
    yellow: {
      main: '#fda92d',
      light: '#FED680',
      dark: '#B66816',
      contrastText: '#1C252E'
    },
    success: {
      main: '#00c292',
      light: '#ebfaf2',
      dark: '#00964b',
      contrastText: '#ffffff'
    },
    lightGrey: {
      main: '#F5F5F5',
      light: '#FFFFFF',
      dark: '#E5E5E5',
      contrastText: '#2D2D2D'
    },
    danger: {
      main: '#e46a76',
      light: '#fdf3f5',
      contrastText: '#ffffff'
    },
    info: {
      main: '#6c65ba',
      light: '#eeedf7'
    },
    error: {
      main: '#e46a76',
      light: '#fdf3f5',
      dark: '#e45a68'
    },
    warning: {
      main: '#fec90f',
      light: '#fff4e5',
      dark: '#fec90f',
      contrastText: '#ffffff'
    },
    text: {
      secondary: '#777e89',
      danger: '#fc4b6c'
    }
  },
  shape: {
    borderRadius: 5
  },
  typography,
  shadows,
  components
}

const DEFAULT_BG_COLOR = '#20232a'

const BuildTheme = () => {
  const mode = THEME_MODE_DARK
  const isDarkMode = true
  const baseMode = {
    palette: {
      mode,
      background: {
        default: isDarkMode ? DEFAULT_BG_COLOR : '#fafbfb',
        dark: isDarkMode ? '#1c2025' : '#ffffff',
        paper: isDarkMode ? '#282C34' : '#ffffff'
      },
      text: {
        primary: isDarkMode ? '#e6e5e8' : 'rgba(0, 0, 0, 0.87)',
        secondary: isDarkMode ? '#adb0bb' : '#777e89'
      },
      inputBorderColor: isDarkMode ? 'rgba(255, 255, 255, 0.12)' : '#dee3e9',
      ssoBorderColor: isDarkMode ? '#42464d' : '#dde3e8'
    }
  }
  const theme = createTheme(_.merge({}, baseTheme, baseMode))
  return theme
}

export { baseTheme, DEFAULT_BG_COLOR, BuildTheme }
